<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加奖金</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">奖金金额</div>
            <el-input v-model="add_Merits" placeholder="请输入奖金金额"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24" class="item">
            <div class="label">备注</div>
            <el-input v-model="add_Remarks" placeholder="请输入备注/奖金说明"></el-input>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props: [],
  data() {
    return {

      loading: false,

      add_Merits:0,
      add_Remarks:'',
      add_DepartmentGainId:'',

    }
  },
  methods: {
    init(row){

      this.add_Merits = 0;
      this.add_Remarks = '';
      this.add_DepartmentGainId = row.id;

    },
    closeSelf() {
      this.$emit("closeMe");
    },


    confirm(){

      if(this.add_Merits === ''){
        this.$message("输入奖金金额");
        return;
      }
      if(this.add_Remarks === ''){
        this.$message("输入备注");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentGain/GovAddTwo',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          merits: this.add_Merits,
          remarks:this.add_Remarks,
          departmentGainId:this.add_DepartmentGainId,
        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeMe");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>

